<template>
  <div class="flex items-center space-x-5 h-72 md:h-full px-3 md:px-10 xl:px-20">
      <div class="w-1/2 md:w-52 flex-grow-0 h-72 md:h-96 flex items-center justify-center">
        <img :src="productSizes[selectedProduct].image" height="300 " width="150" :alt="productSizes[selectedProduct].name" class="w-auto" :class="productSizes[selectedProduct].imageSize"
         />
      </div>    
      <div class="w-1/2 flex h-full">
        <div class="flex items-end">
            <svg class="feather feather-arrow-up-circle animate-bounce stroke-current text-blue-500 -mr-10" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="16 12 12 8 8 12"></polyline><line x1="12" y1="16" x2="12" y2="8"></line></svg>
            <label>
              <input type="range" class="sizeRangeSlider" orient="vertical" min="1" :max="sliderPercentageMax" v-model="sliderPercentageValue">
            </label>
        </div>
        <div class="flex flex-col-reverse justify-between -ml-10">
            <div v-for="(productSize, index) in productSizes">
                <button @click="handleProductSizeClick(index)"
                class="text-left" 
                :class="selectedProduct === index ? 'text-blue-600' : 'text-gray-600'">
                    <span class="text-lg block font-semibold" v-text="productSize.name"></span>
                    <span class="block" v-text="productSize.weight"></span>
                </button>        
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "FriesSizeSlider",
  props: {
    smallFriesImage: String,
    mediumFriesImage: String,
    largeFriesImage: String,
  },
  data() {
    
    return {
      sliderPercentageValue: 50,
      sliderPercentageMax: 99,
      productSizes: [
        {
          name: 'Schanulleke',
          weight: 'Klein',
          image: this.smallFriesImage,
          default: false,
          imageSize: 'h-3/5',
        },
        {
          name: 'Urbanus',
          weight: 'Medium',
          image: this.mediumFriesImage,
          default: true,
          imageSize: 'h-4/5',
        },
        {
          name: 'Obelix',
          weight: 'Groot',
          image: this.largeFriesImage,
          default: false,
          imageSize: 'h-full',
        },
      ],
    };
  },
  created() {
    this.selectedProductSize = this.productSizes.find(function(productSize) {
      return (productSize.default === true);
    });
  },
  computed: {
    selectedProduct() {
      const range         = this.sliderPercentageMax / this.productSizes.length;
      let lastProductSize = 0;

      this.productSizes.forEach((productSize, index) => {
        if ((index) * range <= parseInt(this.sliderPercentageValue)) {
          lastProductSize = index;
        }
      });
      return lastProductSize;
    }
  },
  methods: {
    handleProductSizeClick(index) {
      const range = this.sliderPercentageMax / this.productSizes.length;

      this.sliderPercentageValue = (index * range) + (range / 2);
    }
  }
};
</script>

<style scoped>

</style>